import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Chip,
  Stack,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from '@mui/material';
import {
  Send as SendIcon,
  AutoAwesome as AutoAwesomeIcon,
  Lightbulb as LightbulbIcon,
  Timeline as TimelineIcon,
  Tag as TagIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';

const AIAssistant: React.FC = () => {
  const [message, setMessage] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);

  const handleSubmit = async () => {
    if (!message.trim()) return;
    
    setIsGenerating(true);
    // Simula chamada à API
    setTimeout(() => {
      setSuggestions([
        'Use hashtags específicas do setor imobiliário',
        'Destaque os diferenciais do imóvel',
        'Inclua fotos de alta qualidade',
        'Mencione a localização e infraestrutura',
        'Adicione call-to-action claro'
      ]);
      setIsGenerating(false);
    }, 2000);
  };

  const features = [
    {
      icon: <AutoAwesomeIcon />,
      title: 'Geração de Conteúdo',
      description: 'Crie legendas e textos otimizados para cada rede social'
    },
    {
      icon: <TagIcon />,
      title: 'Sugestão de Hashtags',
      description: 'Receba sugestões de hashtags relevantes e populares'
    },
    {
      icon: <TimelineIcon />,
      title: 'Análise de Tendências',
      description: 'Identifique tendências do mercado imobiliário nas redes sociais'
    },
    {
      icon: <LightbulbIcon />,
      title: 'Ideias de Conteúdo',
      description: 'Receba sugestões de temas e formatos para seus posts'
    },
    {
      icon: <DescriptionIcon />,
      title: 'Otimização de Textos',
      description: 'Melhore seus textos para maior engajamento'
    }
  ];

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Assistente de IA
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Use o assistente para gerar conteúdo, sugestões de hashtags e ideias para suas postagens.
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Descreva o conteúdo que você quer criar..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <Button
                  variant="contained"
                  endIcon={isGenerating ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                  onClick={handleSubmit}
                  disabled={isGenerating || !message.trim()}
                  fullWidth
                >
                  {isGenerating ? 'Gerando sugestões...' : 'Gerar sugestões'}
                </Button>
              </Box>

              {suggestions.length > 0 && (
                <Box>
                  <Typography variant="subtitle1" gutterBottom>
                    Sugestões:
                  </Typography>
                  <List>
                    {suggestions.map((suggestion, index) => (
                      <React.Fragment key={index}>
                        <ListItem>
                          <ListItemIcon>
                            <LightbulbIcon color="primary" />
                          </ListItemIcon>
                          <ListItemText primary={suggestion} />
                        </ListItem>
                        {index < suggestions.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Recursos do Assistente
              </Typography>
              <List>
                {features.map((feature, index) => (
                  <React.Fragment key={index}>
                    <ListItem>
                      <ListItemIcon>
                        {feature.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={feature.title}
                        secondary={feature.description}
                      />
                    </ListItem>
                    {index < features.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AIAssistant;